import { Component } from '@angular/core';
import { UIBlockingService } from '../../core/ui-blocking.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PendingApplicationsService } from '../pending-applications.service';
import { ToastNotificationService } from '../../core/toast-notification.service';
import { PendingApplicationDetails } from '../DTOs/pending-application-details';
import { SavePendingAppRequest } from '../DTOs/save-pending-app-request';
import { MembershipLevelOption } from '../DTOs/membershipLevelOption';
import { CommonLibrary } from '../../core/common-library';

@Component({
  selector: 'app-edit-membership-information-modal',
    templateUrl: './edit-membership-information-modal.component.html',
    providers: [UIBlockingService]
})
export class EditMembershipInformationModalComponent {
    constructor(private activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private pendingApplicationService: PendingApplicationsService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService) { }

    membershipLevelCtrl = new FormControl("membershipLevel", [Validators.required]);
    totalCtrl = new FormControl("total", [Validators.required]);
    paymentTypeCtrl = new FormControl("paymentType");
    autoRenewCtrl = new FormControl("autoRenew", [Validators.required]);
    overridePaymentCtrl = new FormControl("overridePayment", [Validators.required]);

    cardNumberCtrl = new FormControl("cardNumber");
    cardExpirationCtrl = new FormControl("cardExpiration");
    CVVCtrl = new FormControl("cvv");
    //termsAndConditionsCtrl = new FormControl("termsAndConditions", [Validators.requiredTrue]);
    //privacyPolicyCtrl = new FormControl("privacyPolicy", [Validators.requiredTrue]);
    routingNumberCtrl = new FormControl("routingNumber");
    accountNumber1Ctrl = new FormControl("accountNumber1");
    accountNumber2Ctrl = new FormControl("accountNumber2");

    manageMembershipInfoForm: FormGroup = new FormGroup({
        membershipLevel: this.membershipLevelCtrl,
        total: this.totalCtrl,
        paymentType: this.paymentTypeCtrl,
        autoRenew: this.autoRenewCtrl,
        cardNumber: this.cardNumberCtrl,
        cardExpiration: this.cardExpirationCtrl,
        cvv: this.CVVCtrl,
        routingNumber: this.routingNumberCtrl,
        accountNumber1: this.accountNumber1Ctrl,
        accountNumber2: this.accountNumber2Ctrl,
        overridePayment: this.overridePaymentCtrl,
        //termsAndConditions: this.termsAndConditionsCtrl,
        //privacyPolicy: this.privacyPolicyCtrl
    });
    app: PendingApplicationDetails;
    validationTriggered = false;
    isBusy = false;
    membershipLevelOptions: MembershipLevelOption[];

    membershipLevel() { return this.manageMembershipInfoForm.get('membershipLevel').value }
    total() { return this.manageMembershipInfoForm.get('total').value }
    paymentType() { return this.manageMembershipInfoForm.get('paymentType').value }
    autoRenew() { return this.manageMembershipInfoForm.get('autoRenew').value }
    overridePayment() { return this.manageMembershipInfoForm.get("overridePayment").value }

    cardNumber() { return this.manageMembershipInfoForm.get('cardNumber').value }
    cardExpiration() { return this.manageMembershipInfoForm.get('cardExpiration').value }
    cvv() { return this.manageMembershipInfoForm.get('cvv').value }
    routingNumber() { return this.manageMembershipInfoForm.get('routingNumber').value }
    accountNumber1() { return this.manageMembershipInfoForm.get('accountNumber1').value }
    accountNumber2() { return this.manageMembershipInfoForm.get('accountNumber2').value }
    accountNumbersMatchError: boolean = false;

    ngOnInit() {
        this.pendingApplicationService
            .getMembershipLevelInfo()
            .subscribe(
                {
                    next: (data) => {
                        this.membershipLevelOptions = data;
                    },
                    error: (err) => {
                        this.notificationService.error(err);
                    },
                    complete: () => {
                    }
                });
        this.resetManageMembershipForm();
    }
    private resetManageMembershipForm(): void {
        this.manageMembershipInfoForm.reset();
        this.manageMembershipInfoForm.patchValue({
            membershipLevel: this.app.membershipLevel.value,
            total: (this.app.price > 0) ? this.app.price : CommonLibrary.getMembershipPriceForLevel(this.app.membershipLevel.value, this.app.employeeCount.value),
            paymentType: this.app.paymentType,
            autoRenew: this.app.isAutoRenew,
            overridePayment: false,
        });
        this.manageMembershipInfoForm.get('membershipLevel').valueChanges.subscribe(valString => {
            this.membershipPriceUpdate(valString);
        });
        this.manageMembershipInfoForm.get('paymentType').valueChanges.subscribe(val => {
            var hasPayment = this.app.paymentAccountId != null;
            this.clearPaymentValidators();
            this.setPaymentValidators(hasPayment, val);
        });
    }
    membershipPriceUpdate(valString) {
        var price = CommonLibrary.getMembershipPriceForLevel(valString, this.app.employeeCount.value);
        this.manageMembershipInfoForm.patchValue({ 'total': price });
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }

    setPaymentValidators(hasPayment, val) {
        if (!hasPayment && val == 1) {
            this.manageMembershipInfoForm.get('cardNumber').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('cardExpiration').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('cvv').setValidators(Validators.required);
        }
        else if (!hasPayment && val == 2) {
            this.manageMembershipInfoForm.get('routingNumber').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('accountNumber1').setValidators(Validators.required);
            this.manageMembershipInfoForm.get('accountNumber2').setValidators(Validators.required);
        }
        this.manageMembershipInfoForm.get('routingNumber').updateValueAndValidity();
        this.manageMembershipInfoForm.get('accountNumber1').updateValueAndValidity();
        this.manageMembershipInfoForm.get('accountNumber2').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cardNumber').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cardExpiration').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cvv').updateValueAndValidity();
    }

    clearPaymentValidators() {
        this.manageMembershipInfoForm.get('cardNumber').clearValidators();
        this.manageMembershipInfoForm.get('cardExpiration').clearValidators();
        this.manageMembershipInfoForm.get('cvv').clearValidators();
        this.manageMembershipInfoForm.get('routingNumber').clearValidators();
        this.manageMembershipInfoForm.get('accountNumber1').clearValidators();
        this.manageMembershipInfoForm.get('accountNumber2').clearValidators();

        this.manageMembershipInfoForm.get('routingNumber').updateValueAndValidity();
        this.manageMembershipInfoForm.get('accountNumber1').updateValueAndValidity();
        this.manageMembershipInfoForm.get('accountNumber2').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cardNumber').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cardExpiration').updateValueAndValidity();
        this.manageMembershipInfoForm.get('cvv').updateValueAndValidity();
    }

    saveMembershipInfo() {
        if (this.overridePayment()) {
            this.manageMembershipInfoForm.get("paymentType").setValidators(Validators.required);
            this.setPaymentValidators(false, this.paymentType());
        }
        else {
            this.manageMembershipInfoForm.get("paymentType").clearValidators();
            this.clearPaymentValidators();
        }
        this.manageMembershipInfoForm.get("paymentType").updateValueAndValidity();

        for (var i in this.manageMembershipInfoForm.controls) {
            this.manageMembershipInfoForm.controls[i].markAsTouched();
        }
        if (!this.manageMembershipInfoForm.valid) return;

        if (this.paymentType() == 2 && this.accountNumber1() != this.accountNumber2()) {
            this.accountNumbersMatchError = true;
            return;
        }

        var total = (this.total().toString()).replace(/[$,]/g, '');
        if (Number.isNaN(parseFloat(total))) {
            this.notificationService.warning("Please update total to a specific price.");
            return;
        }

        this.blockUI.start();
        var request = new SavePendingAppRequest(
            this.app.appId, this.app.companyName, this.app.employeeCount.value, this.app.businessPhone,
            this.app.businessAddress, this.app.businessCity, this.app.businessState, this.app.businessZip, this.app.minorityCerts?.map(x => x.value),
            this.app.liaisonFirstName, this.app.liaisonLastName, this.app.liaisonEmail, this.app.liaisonPhone, this.app.liaisonTitle,
            this.membershipLevel(),
            parseFloat(total),
            this.paymentType(),
            this.autoRenew()
        );
        if (this.overridePayment()) {
            request.overridePayment = true;
            if (this.paymentType() == 1) {
                request.cardNumber = this.cardNumber();
                request.cardExpiration = this.cardExpiration();
                request.cvv = this.cvv();
            }
            else {
                request.routingNumber = this.routingNumber();
                request.accountNumber1 = this.accountNumber1();
                request.accountNumber2 = this.accountNumber2();
            }
        }
        //this.blockUI.stop();

        this.pendingApplicationService.UpdatePendingAppInfo(request)
            .subscribe({
                next: (data) => {
                },
                error: (err) => {
                    console.log(err);
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                },
                complete: () => {
                    this.blockUI.stop();
                    this.activeModal.close();
                }
            })
    }

}
